<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "BranchAssignment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAssignment.vue